module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","newExam":"Neue Prüfung","save":"Speichern","thereAreItemsThatRequireYourAttention":"Es gibt Felder, die Ihre Aufmerksamkeit erfordern."},"en":{"cancel":"Cancel","newExam":"New exam","save":"Save","thereAreItemsThatRequireYourAttention":"There are items that require your attention."}}')
  delete Component.options._Ctor
}
